module.exports = __webpack_public_path__ + "static/images/edit-pencil-sku.449f71365875128a7b09ff026d8d7661.svg";